import { reportError, ObservabilityErrorSeverity } from '@Services/observability/initObservability';

const UNSUPPORTED_COLOR_PATTERN = /(oklch|lch|lab|color|hwb|color-mix)\s*\([^)]*\)/gi;

const FALLBACK_COLOR = '#808080';

const hasUnsupportedColor = (value: string): boolean => {
  if (!value) return false;
  UNSUPPORTED_COLOR_PATTERN.lastIndex = 0;
  return UNSUPPORTED_COLOR_PATTERN.test(value);
};

const removeUnsupportedColors = (value: string): string => {
  UNSUPPORTED_COLOR_PATTERN.lastIndex = 0;
  return value.replace(UNSUPPORTED_COLOR_PATTERN, FALLBACK_COLOR);
};

const sanitizeElementStyles = (element: HTMLElement) => {
  try {
    const inlineStyle = element.getAttribute('style');
    if (inlineStyle && hasUnsupportedColor(inlineStyle)) {
      element.setAttribute('style', removeUnsupportedColors(inlineStyle));
    }

    const computedStyle = window.getComputedStyle(element);
    for (let i = 0; i < computedStyle.length; i++) {
      const property = computedStyle[i];
      const value = computedStyle.getPropertyValue(property);
      if (hasUnsupportedColor(value)) {
        element.style.setProperty(property, removeUnsupportedColors(value));
      }
    }
  } catch (error) {
    reportError({
      metadata: {
        name: 'Failed to sanitize element',
        message: `${error instanceof Error ? error.message : String(error)}`,
      },
      severity: ObservabilityErrorSeverity.ERROR,
    });
  }
};

export const sanitizeElementTree = (element: HTMLElement) => {
  sanitizeElementStyles(element);

  Array.from(element.children).forEach((child) => {
    if (child instanceof HTMLElement) {
      sanitizeElementTree(child);
    }
  });
};

export const cloneElement = (element: HTMLElement) => {
  return element.cloneNode(true) as HTMLElement;
};

export const cleanupClonedElement = (element: HTMLElement) => {
  try {
    element.parentNode?.removeChild(element);
  } catch (error) {
    reportError({
      metadata: {
        name: 'Failed to cleanup cloned element',
        message: `${error instanceof Error ? error.message : String(error)}`,
      },
      severity: ObservabilityErrorSeverity.ERROR,
    });
  }
};
